<template>
  <section class="hbox stretch">
    <div class="content-main">
      <el-table :data="rows" style="width: 100%">
        <el-table-column    prop="MerchantName" label="所属商家" > </el-table-column>
        <el-table-column    prop="TotalValue"  label="总额" > </el-table-column>
        <el-table-column    prop="AvailableValue"  label="可用余额" > </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
        :current-page="serch.pageIndex"
        :page-size="serch.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="serch.totalCount">
      </el-pagination>
    </div>
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {    
    props:{
      memberId:0
    },
    data (){
      return {
        name:'',
        rows:[],
        serch:{          
          pageIndex:1,
          pagesize:10,
          totalCount:0,
          memberId:0,
          sort:'Id desc',
        }
      }
    },
    components:{          
    },    
    watch:{
      memberId(newV,oldV){
        this.serch.memberId = newV
        this.serch.pageIndex = 1
        this.GetData()
      }
    },
    computed:{
    },
    mounted(){
    },
    methods:{     
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/member/ValueCards',
          params: that.serch
        }).then(function (resp) {
          that.serch.totalCount = resp.data.totalCount
          that.rows = resp.data.data
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleCurrentChange(val) {
        this.serch.pageIndex = val
        this.GetData()
      }
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
.map
  width: 100%;
  height: 200px;
</style>